<template>
  <div class="flex sm:flex-row flex-col-reverse h-3/4 max-w-4xl mx-auto py-10">
    <div class="flex flex-col p-8 justify-center">
      <p
        class="inline self-start xl:w-2/3 h-auto text-4xl text-left font-bold sm:pt-10 text-black break-words"
      >
        {{ title }} <span class="mini-sunset">{{ highlight }}</span>
      </p>

      <p
        class="self-start text-left text-gray-600 text-base sm:w-3/4 h-hit py-4"
      >
        {{ subtitle }}
      </p>
    </div>
    <!-- <div class="flex justify-center items-center py-8">
      <img
        class="self-center lg:mr-20 rounded-lg"
        src="@/assets/cover.png"
        alt=""
      />
    </div> -->
    <div class="xl:w-1/3 h-auto px-10 flex justify-center items-center py-8">
      <img
        class=" self-center lg:mr-20 w-full h-auto rounded-lg"
        :src="require('@/assets/' + this.imgSource + '')"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Intro",
  props: {
    title: String,
    subtitle: String,
    imgSource: String,
    highlight: String
  },
};
</script>

<style lang="css"></style>
